/**
 * @Description: 浏览器下载
 * @author: shuo.li
 * @date: 2021-11-3 11:12
 * @lastEditors:
 * @lastEditTime:
 * @param {String} data
 * @param {String} fileName
 * @returns {undefined}
 */
export function downloadFile(data, fileName) {
  if ("msSaveOrOpenBlob" in navigator) {
    window.navigator.msSaveOrOpenBlob(new Blob([data]), fileName);
  } else {
    const blob = new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    const link = window.document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.setAttribute("download", decodeURIComponent(fileName));
    window.document.body.appendChild(link);
    link.click();
    window.document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}
